import { useDealer } from "src/hooks/useDealer";
import { Link } from "react-router-dom";
import {
  FilesIcon,
  FilesSelectedIcon,
  UserAccountIcon,
  UserAccountSelectedIcon,
  DashboardSquareIcon,
  DashboardSquareSelectedIcon,
} from "src/assets/icons";

const data = {
  dashboard: {
    href: "dashboard",
    title: "Dashboard",
    icon: DashboardSquareIcon,
    selectedIcon: DashboardSquareSelectedIcon,
  },
  applications: {
    href: "applications",
    title: "Applications",
    icon: FilesIcon,
    selectedIcon: FilesSelectedIcon,
  },
  employees: {
    href: "employees",
    title: "Employees",
    icon: UserAccountIcon,
    selectedIcon: UserAccountSelectedIcon,
  },
  dealers: {
    href: "dealers",
    title: "Dealers",
    icon: UserAccountIcon,
    selectedIcon: UserAccountSelectedIcon,
  },
  resources: {
    href: "resources",
    title: "Resources",
    icon: DashboardSquareIcon,
    selectedIcon: DashboardSquareSelectedIcon,
  },
};
export default ({
  forPage,
  isCurrent,
}: {
  forPage: keyof typeof data;
  isCurrent: boolean;
}) => {
  const { dealer_id } = useDealer();
  const Icon = isCurrent ? data[forPage].selectedIcon : data[forPage].icon;

  return (
    <Link
      to={`/${dealer_id}/${data[forPage].href}`}
      className="flex flex-row h-[34px] items-center no-underline group"
    >
      {/* Indicator Nub */}
      <div
        className={`bg-gradient-to-b from-[rgba(64,117,255,1)] to-[rgba(60,113,251,1)] border border-[rgba(0,92,214,0.01)] rounded-[120px] h-2 -ml-[5px] w-[11px] ${
          isCurrent ? "visible" : "invisible"
        }`}
        style={{
          boxShadow: "inset -2px 0px 0px -1.1px rgba(255, 255, 255, 0.2)",
        }}
      />

      {/* Content - Pill-shaped background */}
      <div className="relative flex flex-row items-center gap-4 h-[30px] my-0 mx-[15px] ml-[30px] py-2 px-0 w-full z-[1]">
        {/* Before pseudo-element (left rounded edge) */}
        <div
          className={`absolute block h-[30px] top-0 -left-[30px] ml-[15px] w-[30px] -z-[1] rounded-tl-[50%] rounded-bl-[50%] transition-colors duration-[250ms] ease-linear ${
            isCurrent
              ? "bg-[rgba(229,235,253,1)] group-hover:bg-[rgba(229,235,253,1)]"
              : "bg-transparent group-hover:bg-[rgba(235,238,243,1)]"
          }`}
        />

        {/* Main content background */}
        <div
          className={`absolute inset-0 -z-[1] transition-colors duration-[250ms] ease-linear ${
            isCurrent
              ? "bg-[rgba(229,235,253,1)] group-hover:bg-[rgba(229,235,253,1)]"
              : "bg-transparent group-hover:bg-[rgba(235,238,243,1)]"
          }`}
        />

        {/* After pseudo-element (right rounded edge) */}
        <div
          className={`absolute block h-[30px] top-0 -right-[30px] mr-[15px] w-[30px] -z-[1] rounded-tr-[50%] rounded-br-[50%] transition-colors duration-[250ms] ease-linear ${
            isCurrent
              ? "bg-[rgba(229,235,253,1)] group-hover:bg-[rgba(229,235,253,1)]"
              : "bg-transparent group-hover:bg-[rgba(235,238,243,1)]"
          }`}
        />

        {/* Icon */}
        <div className="h-[18px] w-[18px]">
          <Icon />
        </div>

        {/* Title */}
        <div
          className={`text-sm ${
            isCurrent ? "text-[rgba(20,83,245,1)]" : "text-[rgba(74,84,102,1)]"
          }`}
        >
          {data[forPage].title}
        </div>
      </div>
    </Link>
  );
};
